<template>
	<div class="slider-wrapper">
		<div
			:class="'panel explist ' +
				(isHeaderIndent? ' mt-0 pt-1 ' : '') +
				(isFooterIndent? ' mb-0 pb-1 ' : '') +
				block.appearance"
		>
			<div class="container">
				<div v-if="isHeaderVisible" :class="'panel_header' + (isBrand ? ' sk' : '')">
					<div class="row align-items-end">
						<div class="col-12">
							<h2 v-if="block.block_title === null && 'type_titles' in fetchedData">
								Спикеры {{ fetchedData.type_titles.title_genitive }}
							</h2>
							<h2 v-else>
								{{ block.block_title }}
							</h2>
							<div
								v-if="block.description"
								class="description"
								v-html="block.description"
							/>
						</div>
					</div>
				</div>

				<div
					v-if="block.items"
					v-swiper:Slider="swiperOption"
					class="panel-slider slider mb-3"
					@slideChange="initLoopMode"
				>
					<div class="swiper-wrapper">
						<div
							v-for="(slide, index) in slides"
							:key="index"
							class="swiper-slide"
						>
							<people
								v-if="slide && slide.length"
								:items="slide"
							/>
						</div>
					</div>
				</div>

				<div v-if="isFooterVisible" class="panel_footer">
					<div v-if="block.footer" class="description" v-html="block.footer" />
				</div>
				<div class="row justify-content-between">
					<div class="col-auto">
						<dynamic-button
							v-if="block.button"
							:button="block.button"
							:block-id="block.id"
							:scenario="block.scenario"
						/>
					</div>
					<div class="col-auto">
						<div class="swiper-navigation">
							<div :id="prevElId" class="btn btn-outline-primary icon-arrow_prev" />
							<div :id="nextElId" class="btn btn-outline-primary icon-arrow_next" />
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {
	Swiper,
	SwiperSlide,
	directive,
} from 'vue-awesome-swiper';
import panel from '~/mixins/panel';
import People from '~/components/blocks/people/People.vue';

export default {
	name: 'PanelConferenceSpeakersSlider',
	components: {
		People,
		Swiper,
		SwiperSlide,
	},
	directives: {
		swiper: directive,
	},
	mixins: [panel],
	props: {
		fetchedData: { type: Object, required: true },
	},
	data() {
		return {
			swiperOption: {
				slidesPerView: 4,
				loop: true,
				//cssMode: true,
				pagination: {
					el: '.swiper-pagination',
					clickable: true,
				},
				navigation: {
					nextEl: `#swiper-teaser-next_${this.block.id}`,
					prevEl: `#swiper-teaser-prev_${this.block.id}`,
					disabledClass: 'disabled',
				},
				breakpoints: {
					320: {
						slidesPerView: 1,
					},
					840: {
						slidesPerView: 2,
					},
					1260: {
						slidesPerView: 4,
					},
				},
			},
		};
	},
	computed: {
		slides() {
			if (this.block.items) {
				const size = 1;
				const subarray = [];

				// eslint-disable-next-line no-plusplus
				for (let i = 0; i < Math.ceil(this.block.items.length / size); i++) {
					subarray[i] = this.block.items.slice((i * size), (i * size) + size);
				}
				const merged = [].concat.apply([], subarray);
				return subarray;
			}

			return [];
		},
		prevElId() {
			return this.swiperOption.navigation.prevEl.slice(1);
		},
		nextElId() {
			return this.swiperOption.navigation.nextEl.slice(1);
		},
	},
	methods: {
		initLoopMode() {
			this.Slider.loopDestroy();
			this.Slider.loopCreate();
		},
	},
};
</script>

<style lang="scss">

.slider-wrapper {
	.panel-slider {
		display: flex;
		flex-wrap: wrap;
		border-top: 1px solid;
		border-bottom: 1px solid;
		padding: 1.5rem 0;
	}

	.swiper-wrapper {
		align-items: stretch!important;
	}

	.swiper-slide {
		height: unset;
		border-left: 1px solid;

		&.swiper-slide-active {
			border-left: none;
		}
	}

	.experts_block {
		height: 100%;
		border-bottom: 0 !important;

		.experts_list {
			margin-left: 0 !important;
			height: 100%;
			display: flex;
			flex-direction: column;
			& > li {
				padding-bottom: 0rem;
			}
		}
	}

	.align-self-center {
		display: block;
		text-align: unset !important;
		align-items: unset !important;
	}

	.expert {
		padding-left: 0 !important;
		justify-content: unset !important;

		&::before {
			border-right: 0 !important;
		}
	}

	.expert-style {
		flex: 1;
		max-width: 100%;
		border-top: 0 !important;
	}

	.bio-style {
		min-height: 236px;
		flex: 1 1 auto;
		justify-content: space-between;
		max-width: 100%;
		text-align: center;
		border: 0 !important;

		.bio_bottom {
			width: 100%;
			display: flex;
			justify-content: center;
		}

		p {
			min-height: 112px;
		}
	}
}
</style>
